// Dev-only logger.
//
// Why this exists: the codebase had ~45 `console.error` calls that fired
// in production builds, leaking error details (sometimes including
// partial API responses) into visitors' browser consoles.
//
// In production these become no-ops. In dev they pass straight through to
// the real console so the dev tools experience is unchanged.
//
// Usage:
//   import { devError, devWarn, devLog } from '../lib/devLog';
//   try { ... } catch (err) { devError('Fetch failed', err); }

const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

// eslint-disable-next-line no-console
export const devLog = isProd ? noop : (...args) => console.log(...args);
// eslint-disable-next-line no-console
export const devWarn = isProd ? noop : (...args) => console.warn(...args);
// eslint-disable-next-line no-console
export const devError = isProd ? noop : (...args) => console.error(...args);
